import React, { useEffect } from 'react';
import { CollectionItemProps } from './Types/CollectionItem';
import Icon from '../Icon';

const CollectionItem = (props: CollectionItemProps) => {
  return (
    <a
      href={'/api/collectionstore/' + props.fileName}
      className="flex cursor-pointer items-center justify-between rounded-md border-[1px] border-solid border-gray-200 bg-gray-50 px-3 py-4"
    >
      <Icon className="h-10 w-10" name="zipfile" />
      <div className="m-2 flex-1">
        {props.name && <p className="text-lg font-medium">{props.name}</p>}
        {props.fileName && (
          <span>
            {props.fileName} ({props.fileSize})
          </span>
        )}
      </div>
      <Icon className="h-6 w-6" name="download" />
    </a>
  );
};

export default CollectionItem;
